import { currentYear } from '@/app/constants'
import { Component } from '@angular/core'

@Component({
  selector: 'app-footer',
  imports: [],
  template: `
    <footer class="footer">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 text-center">
            Copyright © {{ currentYear }} Department of Groundwater Resources , All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  `,
})
export class Footer {
  currentYear = currentYear
}
